/* eslint-disable */
import { useRouter, useRoute } from "vue-router";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import { performLogout } from "@/Shared/logout";
import {
    ref,
    computed,
    onBeforeMount,
    onMounted,
    onUnmounted
  } from "vue";

export default {
    name: "landingpage",
    setup() {
        let valnow = ref("");
        const router = useRouter();
        const profileBlock = ref(false)
        let currentTheme = ref(localStorage.getItem("theme-color"));
        onBeforeMount(async () => {
         store.dispatch("setNavbar",false)
         if (currentTheme.value == null) {
          localStorage.setItem("theme-color", "theme-default");
          currentTheme.value = localStorage.getItem("theme-color");
        }
        });
        onMounted(() => {
          const pageWrapper = document.getElementById("page-wrapper");
          if (pageWrapper) {
            pageWrapper.style.width = "100%";
          }
        });
        const removeRouterGuard = router.beforeEach((to, from, next) => {
          const pageWrapper = document.getElementById("page-wrapper");
          if(to.name!='profileSettings'){
            store.dispatch("setNavbar",true)
            pageWrapper?.style.removeProperty("width");
          }     
          else if (pageWrapper) {
            pageWrapper.style.width="100%"
          }
          next()
        });
        onUnmounted(() => {
          removeRouterGuard();
        });
    let usersdetails = computed(function () {
      valnow.value = store.getters.getStudyIs;
      return jwt_decode(store.getters.getIdToken);
    });
    let edcRoute = computed(function () {
      const dashbrd = store.getters.getdefaultdashboard;
      return dashbrd ? `/${dashbrd}` : "/home";
    });
    let rollsprivilages = computed(function () {
      let rprivileges = store.getters.getRolesprivilegeData;
      let dashbrd = store.getters.getdefaultdashboard;
      if (rprivileges != "test test," && useRoute().path == "/noprivilege") {
        router.push(`/${dashbrd}`);
      }
      return store.getters.getRolesprivilegeData;
    });
    function openThirdPartyApp() {
      window.open(
        process.env.VUE_APP_THIRD_PARTY_SAML_URL,
        "_blank",
        "noopener,noreferrer"
      );
    }
    function displayProfile() {
        const profile = document.querySelector(".profile-block");
        const userProfile = document.querySelector(".tool-tip")
        if (profile.style.display == "block") {
          profile.style.display = "none";
        } else profile.style.display = "block";
        if (userProfile.style.display == "block") {
            userProfile.style.display = "none";
          }
      }
      async function logout() {
        await performLogout();
      }
      function setstatus(screen) {
        store.dispatch("setCollapse",false)
        switch (screen) {
            case 'AI/Ml':
                store.dispatch("setDefaultMenu", "AI/Ml");
                break;
            case 'Analytical':
                store.dispatch("setDefaultMenu", "Analytical");
                break;
            case 'clinical':
                store.dispatch("setDefaultMenu", "Clinical");
                break;
            case 'stats':
              store.dispatch("setDefaultMenu", "Stats");
              break;
            case 'fhir':
              store.dispatch("setDefaultMenu", "FHIR");
              break;          
            case 'etmf':
              store.dispatch("setDefaultMenu", "ETMF");
              break;
            case 'epro':
              store.dispatch("setDefaultMenu", "EPRO");
              break;
            case 'alerts':
              store.dispatch("setDefaultMenu", "alerts");
              break;
            case 'CTMS':
              store.dispatch("setDefaultMenu", "CTMS");
              break;
            default:
                console.warn("Invalid screen type:", screen);
                break;
        }
    }
      function returnToEdc() {
        store.dispatch("setCollapse", false);
        store.dispatch("setDefaultMenu", "");
      }
      async function expandSidebar() {
        let x = document.getElementsByClassName("theme-menu")[0];
        if (x.style.display == "block") {
          x.style.display = "none";
        } else x.style.display = "block";
      }

      function switchTheme(theme) {
        localStorage.setItem("theme-color", theme);
        currentTheme.value = localStorage.getItem("theme-color");
      }

      return {
        openThirdPartyApp,
        usersdetails,
        displayProfile,
        valnow,
        profileBlock,
        logout,
        setstatus,
        returnToEdc,
        switchTheme,
        expandSidebar,
        rollsprivilages,
        edcRoute
      };

    }
}
